var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52596 6.26906L3.85596 17.9663L9.00002 16.0312L14.1441 18L9.52596 6.26906ZM8.09158 2.15437C8.09158 1.67625 8.04658 1.1925 8.02408 0.748125H8.04939L8.53596 1.68469L10.1897 4.54781H10.7775V0H10.2347V2.35969C10.2347 2.82938 10.2769 3.33563 10.3106 3.79688H10.2769L9.78752 2.86031L8.13939 0H7.55158V4.53656H8.09721L8.09158 2.15437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.15b9b747aa7fa45432850314ee95bbfb.svg";
export { ForwardRef as ReactComponent };